var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReferralNavIcon = function SvgReferralNavIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    x: 5,
    y: 2,
    fill: "#8C2E89",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4AA2C4",
    d: "M1 16.8A4.8 4.8 0 0 1 5.8 12h6.4a4.8 4.8 0 0 1 4.8 4.8 3.2 3.2 0 0 1-3.2 3.2H4.2A3.2 3.2 0 0 1 1 16.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBD15D",
    d: "M20.854 5.354a.5.5 0 0 0-.708-.708zM15 10a.5.5 0 0 0 .5.5H20a.5.5 0 0 0 0-1h-4v-4a.5.5 0 0 0-1 0zm5.146-5.354-5 5 .708.708 5-5z"
  })));
};
export default SvgReferralNavIcon;